module.exports = "<div [style.padding.px]=\"12\" [innerHtml]=\"privacyPolicy\"></div>\n"